import { Button, TableHeader } from '@unimed-fesp/components';
import styled from 'styled-components';

export const Container = styled.div``;
export const ButtonActions = styled(Button)`
  border: none;
`;

export const HoverActions = styled.div`
  display: flex;
  justify-content: space-between;
  &:hover {
    border-radius: 5px;
    cursor: pointer;
    word-break: normal;
  }
  z-index: 1;
`;
export const CustomTableHeader = styled(TableHeader)`
  z-index: 1;
`;
